import React from "react";
import { VariantQuantity } from "../updateQuantityHelper";
import { NoTranslate } from "@/components/Common/NoTranslate";

interface NonTrackedReturnInventoryCardProps {
    variant: VariantQuantity;
    moveToAvailableCount: number;
    returnRestockCount: number;
}

export const NonTrackedReturnInventoryCard = ({
    variant,
    moveToAvailableCount,
    returnRestockCount,
}: NonTrackedReturnInventoryCardProps) => {
    return (
        <div
            className="rounded border border-gray-lighter text-sm"
            data-testid={`return-inventory-table-for-${variant.variantName}`}
        >
            <div className="flex items-center justify-between bg-gray-lighter px-4 py-2">
                <NoTranslate className="font-bold">{variant.variantName}</NoTranslate>
                <span className="text-gray-dark" data-testid="return-inventory-header">
                    Inventory not tracked
                </span>
            </div>
            <div className="space-y-2 p-4 text-gray-dark" data-testid="return-inventory-row">
                {moveToAvailableCount > 0 && (
                    <div className="flex items-center justify-between">
                        <span>Move to available</span>
                        <var data-var="moveToAvailableCount" className="font-bold">
                            {moveToAvailableCount}
                        </var>
                    </div>
                )}
                {returnRestockCount > 0 && (
                    <div className="flex items-center justify-between">
                        <span>Return</span>
                        <var data-var="returnRestockCount" className="font-bold">
                            {returnRestockCount}
                        </var>
                    </div>
                )}
            </div>
        </div>
    );
};
